import { hash } from "rsvp";
import Route from "@ember/routing/route";
import { service } from "@ember/service";
import { findRecord } from "@warp-drive/legacy/compat/builders";

export default class DashboardInviteRoute extends Route {
  @service store;

  model(params) {
    return hash({
      invite: this.store.request(findRecord("invite", params.invite_code)).then((response) => response.content),
    });
  }
}
